/**
 * Склейка обновлений до одного кадра.
 *
 * Сообщения сокета приходят каждое своей задачей цикла событий, поэтому
 * автоматическое пакетирование React их НЕ объединяет: сто дельт в секунду
 * дают сто перерисовок. Отсюда собственный батчер поверх requestAnimationFrame.
 *
 * В фоновой вкладке rAF не вызывается вовсе, и очередь росла бы без предела —
 * поэтому там работает таймер, а на возврате в фокус делается принудительный
 * слив, чтобы оператор не увидел мгновение устаревшей картинки.
 */
export interface Batcher {
  schedule(): void;
  flushNow(): void;
}

const HIDDEN_FLUSH_MS = 250;

export function createBatcher(flush: () => void): Batcher {
  let scheduled = false;

  const run = () => {
    scheduled = false;
    flush();
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    if (typeof document !== "undefined" && document.hidden) {
      window.setTimeout(run, HIDDEN_FLUSH_MS);
    } else {
      requestAnimationFrame(run);
    }
  };

  const flushNow = () => {
    scheduled = false;
    flush();
  };

  if (typeof document !== "undefined") {
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        // rAF, взведённый до ухода в фон, в фоновой вкладке не сработает
        // вовсе, а флаг scheduled заблокировал бы и все будущие взводы —
        // очередь копилась бы без предела до возврата фокуса. Перевзводим
        // слив на таймер; лишний вызов run безвреден: он сливает пустую
        // очередь.
        if (scheduled) window.setTimeout(run, HIDDEN_FLUSH_MS);
      } else {
        flushNow();
      }
    });
  }

  return { schedule, flushNow };
}
